var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"social-nav-header navbar-nav"},_vm._l((_vm.socialMenuPage),function(itemSocialMenuPage,index){return _c('li',{key:index,staticClass:"nav-item scc-nav-item"},[_c('a',{staticClass:"nav-link hover-item-a",attrs:{"href":itemSocialMenuPage.href,"target":"_blank"},domProps:{"innerHTML":_vm._s(itemSocialMenuPage.svg)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }